var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 19.0029C23 19.5334 22.7893 20.0421 22.4142 20.4171C22.0391 20.7922 21.5304 21.0029 21 21.0029H3C2.46957 21.0029 1.96086 20.7922 1.58579 20.4171C1.21071 20.0421 1 19.5334 1 19.0029V8.00293C1 7.4725 1.21071 6.96379 1.58579 6.58872C1.96086 6.21364 2.46957 6.00293 3 6.00293H7L9 3.00293H15L17 6.00293H21C21.5304 6.00293 22.0391 6.21364 22.4142 6.58872C22.7893 6.96379 23 7.4725 23 8.00293V19.0029Z",
    stroke: "#11131F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.0029C14.2091 17.0029 16 15.2121 16 13.0029C16 10.7938 14.2091 9.00293 12 9.00293C9.79086 9.00293 8 10.7938 8 13.0029C8 15.2121 9.79086 17.0029 12 17.0029Z",
    stroke: "#11131F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera2);
export default __webpack_public_path__ + "static/media/camera2.dafb2155dbfa586e65482f87fad47c44.svg";
export { ForwardRef as ReactComponent };